import { Contact } from "../../admin/models/contact.model";
import { GroupStub } from "../../admin/models/group.model";
import { Note } from "./note.model";
import { Address } from "./address.model";
import { RequiredCumulativeFinancialInstrument } from "./financialAssurance.model";

export class OrganizationComplianceDetails {
    orgId: string = '';
    name: string = "";
    isInsuranceCompliant: boolean = false;
    isBondingCompliant: boolean = false;
    isCompliant: boolean = false;
    requiredBonding?: number;
    requiredInsurance?: number;
    insuranceProvided?: number;
    bondingProvided?: number;
    bondingDecisionBasis: string[] = [];
    insuranceDecisionBasis: string[] = [];
    lastUpdatedDate?: Date;
    isWellOwner?: boolean;
    isBrineHauler?: boolean;
    requiredCumulativeFinancialInstruments?: RequiredCumulativeFinancialInstrument[];
}

export enum OperationType {
    None = 0,
    Operator = 1,
    InjectionOperator = 2,
    Driller = 4,
    Bonding = 8,
    LoggingContractor = 16,
    CementContractor = 32,
    BrineHauler = 64,
    PluggingContractor = 128,
    BulkMaterialSupplier = 256,
    ServiceSupplier = 512
}

export class OrganizationStub {
    id: string;
    parentOrganizationId: string;
    secretaryOfStateId?: string;
    isInternal: boolean = false;
    isLegacy: boolean = false;
    hasRegistered: boolean = false;
    isMinimalRegistration: boolean = false;
    name: string = '';
    isDbaName: boolean = false;
    typeCode: string = '';
    isActive: boolean = true;
    complianceStatus: number = 1;
    address: Address = {
        street: '',
        suite: '',
        poBox: '',
        city: '',
        stateCode: '',
        zipCode: '',
    };
    phone: string = '';
    fax: string = '';
    email: string = '';
    departments: Department[] = [];
    historicalOwnerNumber: string = "";
    entityType?: string;
    entityTypeOther?: string;
    governmentType?: string;
    governmentTypeOther?: string;
    cancellationDate?: Date;
    operationType: OperationType;
    status: string;
    noPhone?: boolean;
	responsiblePartyPhone?: string = '';
	dateApproved?: Date | string;
	dateEnforcementExhausted?: Date;
}

export class Organization extends OrganizationStub {
    contacts: Contact[] = [];
    groups: GroupStub[] = [];
    history: OrganizationEvent[] = [];
    notes: Note[] = [];
}

export class OrganizationEvent {
    contact: Contact;
    creatorContactId: string;
    eventType: OrganizationEventType;
    id: string;
    organizationId: string;
    timeStamp: Date;
}

export enum OrganizationEventType {
    OrganizationCreated,
    ApplicationSubmitted,
    AccountApproved,
    OutOfCompliance,
    OrganizationCancelled,
	NameChanged,
	EnforcementExhausted
}

export class Department {
    displayName: string = "";
    id: string = "";
}

export interface mergeFieldsOrgInfo {
    organizationName: string,
    organizationId: string,
    address: Address,
    applicationNumber: string,
}

export class FinancialCompliance {
    isInsuranceCompliant: boolean = false;
    isBondingCompliant: boolean = false;
}

export interface FinancialComplianceSearchSpec {
    organizationIds: string[];
    includeHistoricOwnerNumbers: boolean;
    organizationId?: string;
    historicOwnerNumber?: string;
    exactMatch?: boolean;
}

export interface MassMailingEntry {
    active: boolean,
    cancellationDate?: Date,
    entityType: string,
    inCompliance?: boolean,
    organizationCity: string,
    organizationName: string,
    organizationPOBox: string,
    organizationState: string,
    organizationStreetAddress: string,
    organizationSuite: string,
    organizationZipCode: string,
    primaryContactEmail: string,
    primaryContactName: string,
    primaryContactPhone: string,
    rbdmsOwnerNumber?: string,
    registeredInRICS: boolean,
    registrationDate?: Date,
    ricsOwnerNumber: string,
    
}

